import {Form} from 'react-bootstrap'

const HSDescriptionDetailView = ({hsDescriptionData}) => {
  return (
    <div className='row mt-3'>
      <h3 className='mb-6'>HS Description Detail</h3>
      <div className='row mb-3'>
        <div className='col-md-6 mb-5'>
          <Form.Label>HS Code</Form.Label>
          <div className='data-value'>{hsDescriptionData?.id || '-'}</div>
        </div>
        <div className='col-md-6 mb-5'>
          <Form.Label>HS Version</Form.Label>
          <div className='data-value'>{hsDescriptionData?.version || '-'}</div>
        </div>
      </div>
      <div className='row mb-3 '>
        <div className='col-md-6 mb-5'>
          <Form.Label>Level</Form.Label>
          <div className='data-value'>{hsDescriptionData?.level || '-'}</div>
        </div>
        <div className='col-md-6 mb-5'>
          <Form.Label>Parent</Form.Label>
          <div className='data-value'>{hsDescriptionData?.parent || '-'}</div>
        </div>
      </div>
      <div className='row mb-3'>
        <div className='col-md-6 mb-5'>
          <Form.Label>Description</Form.Label>
          <div className='data-value'>{hsDescriptionData?.description || '-'}</div>
        </div>
        <div className='col-md-6 mb-5'>
          <Form.Label>Description (Fr)</Form.Label>
          <div className='data-value'>{hsDescriptionData?.description_fr || '-'}</div>
        </div>
      </div>
    </div>
  )
}

export default HSDescriptionDetailView
